import { useState } from 'react';

const useModals = initalState => {
	const [modals, setModals] = useState(initalState);

	const toggleModal = name => {
		const updatedModals = Object.keys(modals).reduce((accum, key) => {
			accum[key] = key == name ? !modals[key] : false;
			return accum;
		}, {});

		setModals(updatedModals);
	};

	return {
		toggleModal,
		modals,
		activeModal: Object.keys(modals).filter(key => key)
	};
};

export default useModals;
